import store from '../store';
import axios from 'axios';
import * as Sentry from '@sentry/vue';
import * as SentryTypes from '@sentry/types';

export default function appSetup() {
  axios.interceptors.request.use(request => {
    // Commit state changes directly to the store instance.
    const reservationState = store.state.user;
    if (reservationState) {
      store.commit('user/setState', { property: 'isLoading', value: true });
      store.commit('user/setState', { property: 'networkResponse', value: { status: reservationState.STATUSES.SUCCESS } });
    }
    return request;
  });

  axios.interceptors.response.use(response => {
    const reservationState = store.state.user;
    if (reservationState) {
      store.commit('user/setState', { property: 'isLoading', value: false });
    }
    return response;
  }, error => {
    const reservationState = store.state.user;
    if (reservationState) {
      store.commit('user/setState', { property: 'isLoading', value: false });
    }

    const requestUrl = error.config?.url;
    const isLookupRequest = /^GET$/i.test(error.config?.method) && /\/reservation$/i.test(requestUrl);

    // Update the network response state
    if (error.response && reservationState) {
      store.commit('user/setState', {
        property: 'networkResponse',
        value: { status: error.response.status, message: error.response.data.message },
      });

      // Sentry error reporting
      Sentry.withScope(scope => {
        if (error.response.status < reservationState.STATUSES.SERVER_ERR) {
          scope.setLevel(SentryTypes.Severity.Info);
        }
        // clarify reservation not found message
        if (error.response.status === 404 && isLookupRequest) {
          Sentry.captureException(new Error('Reservation not found based on user input.'));
        } else {
          Sentry.captureException(error);
        }
      });
    } else {
        // Handle network errors without a response
        Sentry.withScope(scope => {
            scope.setLevel(SentryTypes.Severity.Error);
            Sentry.captureException(error);
        });
        store.commit('user/setState', {
            property: 'networkResponse',
            value: { status: 'Network Error', message: error.message }
        });
    }
    return Promise.reject(error);
  });
}